import React from 'react';
import './Legal.css';


const GDPR = () => {
  return (
    <>


      <div className="legal-container">
        <div className="legal-content">
          <div className="legal-section">
            <p><strong>Ultima actualizare:</strong> 28 noiembrie 2024</p>

            <h3>1. Drepturile dumneavoastră conform GDPR</h3>
            <p>Conform Regulamentului General privind Protecția Datelor (GDPR), aveți următoarele drepturi:</p>
            <ul>
              <li><strong>Dreptul de acces:</strong> Puteți solicita o copie a datelor personale pe care le deținem despre dumneavoastră</li>
              <li><strong>Dreptul la rectificare:</strong> Puteți corecta datele inexacte sau incomplete</li>
              <li><strong>Dreptul la ștergere:</strong> Puteți solicita ștergerea datelor personale</li>
              <li><strong>Dreptul la restricționare:</strong> Puteți limita modul în care folosim datele</li>
              <li><strong>Dreptul la portabilitate:</strong> Puteți primi datele într-un format structurat</li>
              <li><strong>Dreptul de opoziție:</strong> Vă puteți opune prelucrării datelor în anumite scopuri</li>
            </ul>

            <h3>2. Cum exercitați aceste drepturi</h3>
            <p>Pentru a exercita oricare dintre aceste drepturi, contactați-ne la:</p>
            <ul>
              <li>Email: m_adi_i@yahoo.com</li>
              <li>Telefon: 0745573126</li>
              <li>Adresă: Str. Privighetorii 36, Maramureș, 430324</li>
            </ul>

            <h3>3. Operator de date</h3>
            <p>Operatorul de date personale este:</p>
            <p><strong>SC CLADIDAV S.R.L.</strong><br />
            CUI: 15903651<br />
            J24/1284/2003<br />
            Str. Privighetorii 36, Maramureș, 430324</p>

            <h3>4. Perioada de stocare</h3>
            <p>Datele sunt păstrate doar pe perioada necesară pentru furnizarea serviciilor și îndeplinirea obligațiilor legale.</p>

            <h3>5. Securitatea datelor</h3>
            <p>Implementăm măsuri tehnice și organizatorice pentru protejarea datelor dumneavoastră:</p>
            <ul>
              <li>Conexiuni securizate HTTPS</li>
              <li>Acces restricționat la date</li>
              <li>Procesare minimă necesară</li>
            </ul>

            <h3>6. Plângeri</h3>
            <p>Aveți dreptul de a depune o plângere la Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP).</p>

            <h3>7. Contact</h3>
            <p>Pentru orice întrebări despre protecția datelor: m_adi_i@yahoo.com</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default GDPR;